// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'chat-solid';

export const Component = () => (
  <path d='M24.5 2.948v15.32c0 .421-.14.748-.422.981-.281.28-.61.42-1.032.42h-2.39v2.897a.921.921 0 0 1-.281.654.928.928 0 0 1-.656.28c-.234 0-.469-.046-.61-.187l-4.734-3.55c-.047-.046-.14-.093-.282-.093H1.953c-.422 0-.75-.14-1.03-.42C.64 19.015.5 18.687.5 18.268V2.949c0-.421.14-.748.422-1.028.281-.28.61-.421 1.032-.421h21.092c.423 0 .75.14 1.032.42.281.281.422.608.422 1.028Z' />
);

export const viewBox = '0 0 25 25';
